import { createContext } from 'react';

export const ListcandidateContext = createContext(null);